module.exports = __webpack_public_path__ + "summernote.cca79100fbabf9354968.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/summernote/font/summernote.eot
// module id = ../../../../../src/assets/summernote/font/summernote.eot
// module chunks = styles